import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { collection, documentId, getDocs, limit, orderBy, query, startAfter } from "firebase/firestore";
import { db } from "../../../../shared/libs/firebaseConfig";

const PAGE_SIZE = 25;
export default function AdminReviewCourseFilter({ value, onChange, disabled }) {
  const [courses, setCourses] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [more, setMore] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const pending = useRef(false);
  const mounted = useRef(true);
  const load = async (after = null) => {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError(false);
    try {
      const result = await getDocs(query(collection(db, "courses"), orderBy(documentId()), ...(after ? [startAfter(after)] : []), limit(PAGE_SIZE + 1)));
      if (!mounted.current) return;
      const page = result.docs.slice(0, PAGE_SIZE);
      const choices = page.map((document) => ({ id: document.id, name: document.data().title || "คอร์สไม่มีชื่อ" }));
      setCourses((previous) => after ? [...previous, ...choices.filter((choice) => !previous.some((item) => item.id === choice.id))] : choices);
      setCursor(page.at(-1) || null); setMore(result.docs.length > PAGE_SIZE);
    } catch { if (mounted.current) setError(true); }
    finally { pending.current = false; if (mounted.current) setBusy(false); }
  };
  useEffect(() => { mounted.current = true; load(); return () => { mounted.current = false; }; }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return <Form.Group controlId="review-course">
    <Form.Label>คอร์ส</Form.Label>
    <Form.Select value={value} onChange={(event) => onChange(event.target.value)} disabled={disabled || busy}>
      <option value="">ทั้งหมด</option>
      {courses.map((course) => <option key={course.id} value={course.id}>{course.name} — {course.id}</option>)}
    </Form.Select>
    <Form.Text>ชื่อคอร์สพร้อม ID เพื่อแยกคอร์สชื่อซ้ำ</Form.Text>
    {busy && <div role="status" className="small">กำลังโหลดคอร์ส...</div>}
    {error && <Alert variant="danger" className="small mt-2">โหลดรายชื่อคอร์สไม่สำเร็จ <Button size="sm" disabled={busy || disabled} onClick={() => load(cursor)}>ลองโหลดคอร์สอีกครั้ง</Button></Alert>}
    {more && !error && <Button size="sm" variant="link" disabled={busy || disabled} onClick={() => load(cursor)}>โหลดคอร์สเพิ่มเติม</Button>}
  </Form.Group>;
}
